import gsap from 'gsap'
import Lenis from '@studio-freight/lenis'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export let lenis, scrollToStart

export const initLenis = () => {

	lenis = new Lenis({
		lerp: 0.1,
		smooth: true,
		direction: 'vertical'
	})

	function raf(time) {
		lenis.raf(time)
		requestAnimationFrame(raf)
	}

	scrollTo()
	requestAnimationFrame(raf)

	lenis.on('scroll', e => {
		if (e.targetScroll > 20) {
			document.body.setAttribute('data-scroll-detected', true)
		} else {
			document.body.removeAttribute('data-scroll-detected')
		}
		ScrollTrigger.update
	})

	gsap.ticker.add((time) => {
		lenis.raf(time * 1000)
	})

	gsap.ticker.lagSmoothing(0)
}

export const scrollTo = () => {

	const links = document.querySelectorAll('[data-scroll-to]')

	if (!links) return

	links.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault()
			const target = link.getAttribute('data-scroll-to')
			const offset = link.getAttribute('data-scroll-offset')
			const targetEl = document.querySelector(target)
			lenis.scrollTo(targetEl, {
				duration: 1.5,
				offset: offset ? Number(offset) : 0,
				easing: (x) => {
					return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2
				}
			})
		})
	})
}

scrollToStart = () => {
	lenis.scrollTo(0, { immediate: true })
}

export default () => { }
